import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {ConcreteHierarchyItemInterface} from '../../classes/concreteLayers/ConcreteHierarchyItemInterface';
import {ConcreteLayerService} from "@src/app/services/concreteLayer/concrete-layer.service";
import {ConcreteLayer} from "@src/app/classes/concreteLayers/ConcreteLayer";

@Injectable()
export class UiAdapterService {


  constructor() {}

  public globalDragEnabled = false;
  private isFirstLoaded = false;
  private _hiddenDetailsSidebar$ = new BehaviorSubject<boolean>(true);
  get onHideDetailsSidebarUpdated$() {
    return this._hiddenDetailsSidebar$.asObservable();
  }

  get globalScreenshotEnabled(): boolean {
    const screenshotParam = new URLSearchParams(window.location.search);
    // console.log('[TEST] screenshot param', screenshotParam.get('shot'));
    return ((screenshotParam.has('shot') && screenshotParam.get('shot') !== '0') || (window.hasOwnProperty('STORIES_ALLOWED') && window['STORIES_ALLOWED']));
  }

  get isDetailsSidebarHidden() {
    return this._hiddenDetailsSidebar$.getValue();
  }

  set hiddenDetailsSidebar(val) {
    this._hiddenDetailsSidebar$.next(val);
  }

  private _selectedItem$ = new BehaviorSubject(null);
  public _selectedConcrete$ = new Subject<ConcreteLayer>();

  get selectedConcrete$() {
    // @ts-ignore
    return this._selectedConcrete$.asObservable();
  }

  set selectedConcrete$(val:any) {
    this.selectedParentId = val.getParentConcreteId();
    this._selectedConcrete$.next(val);
  }

  get selectedItem$() {
    return this._selectedItem$.asObservable();
  }
  set selectedItem$(val: any) {
    if (!val){
      this._selectedItem$.next(val);
      return;
    }
    this.selectedParentId = val.getParentConcreteId();
    if (this.isFirstLoaded) {
      this.hiddenDetailsSidebar = false;
    }
    if (!this.isFirstLoaded) {
      this.isFirstLoaded = true;
    }
    this._selectedItem$.next(val);
    window['_selectedItem'] = val;
  }

  public selectedParent: ConcreteHierarchyItemInterface = null;
  public selectedParentId: string = null;

  get currentSelectedItem(): ConcreteHierarchyItemInterface {
    return this._selectedItem$.getValue();
  }
}
